import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { renameProcedure } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function updateProcedureName({
  AccountId,
  ProcedureId,
  ProcedureName,
}: TVariables): Promise<TResult> {
  const response = await fetch(renameProcedure(AccountId, ProcedureId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(ProcedureName),
  });

  return await response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  ProcedureId: number;
  AccountId: number;
  ProcedureName: string;
};

type TSnapshot = unknown;

function useRenameProcedure(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const { AccountId } = params;
    const renamedResult = await updateProcedureName(params);
    if (renamedResult.Data) {
      queryClient.invalidateQueries(
        ['get_procedure_builder_procedures', AccountId],
        {
          refetchInactive: true,
        },
      );
      queryClient.invalidateQueries(['get_procedure', AccountId], {
        refetchInactive: true,
      });
    } else if (renamedResult.Errors) {
      throw renamedResult;
    }
    return renamedResult;
  });
}

export { useRenameProcedure };
